import { HttpErrorResponse } from '@angular/common/http';
import { RootState } from '@next/core-lib/app';

import { MeasurementsState } from '../../measurements/models/measurements.model';

// add your interfaces for the api responses and state here
// SiteState is the root state of your app module
export interface SiteState extends RootState {
  app: AppState;
  measurements: MeasurementsState;
}

export interface AppState {
  rationComponents: RationComponent[];
}

export interface RationComponent {
  id: number;
  name: string;
}

export enum FormMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export interface CustomHttpErrorResponse extends HttpErrorResponse {
  error: {
    message: string;
  };
}
